export type AppliedAppTheme = 'light' | 'dark'
export const AppliedAppThemes = {
    light: 'light' as AppliedAppTheme,
    dark: 'dark' as AppliedAppTheme
}
